// extracted by mini-css-extract-plugin
export default {"image-container":"Image_image-container__rHXBG","image-label":"Image_image-label__Ozw98"};